import { isEqual } from 'lodash/fp';
import { DateTime } from 'luxon';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { Event, RedactedObjectPaths } from 'dashboard/models/event';
import {
  EventsActions,
  EventsActionType,
  EventsFilterParams,
} from 'dashboard/redux/actions/events';

export type Events = Record<string, Event[]>;

export interface EventsState extends Omit<TableState<EventsFilterParams>, 'sortParams'> {
  events: Events;
  redactedObjectPaths: RedactedObjectPaths;
}

export const getEventsInitialState = (): EventsState => {
  const currentTime = DateTime.local();
  return {
    events: {},
    paginationParams: undefined,
    filters: {
      createdAtStart: currentTime.minus({ weeks: 2 }).startOf('day').toISO(),
      createdAtEnd: currentTime.endOf('day').toISO(),
      names: undefined,
      omni: undefined,
    },
    pageSize: DEFAULT_PAGE_SIZE,
    currentPage: 1,
    redactedObjectPaths: {},
  };
};

export default (state: EventsState = getEventsInitialState(), action: EventsActions) => {
  switch (action.type) {
    case EventsActionType.SetEvents: {
      return {
        ...state,
        events: {
          ...state.events,
          [action.payload.environment.id]: action.payload.events,
        },
        paginationParams: action.payload.paginationParams,
      };
    }

    case EventsActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case EventsActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case EventsActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    case EventsActionType.SetRedactedObjectPaths: {
      return {
        ...state,
        redactedObjectPaths: action.payload.redactedObjectPaths,
      };
    }

    default:
      return state;
  }
};
